// removed by extract-text-webpack-plugin
module.exports = {"colorSecondaryRagRed":"#d2222d","mandatory":"styles-module__mandatory____2b3Em"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/select/styles.module.css
// module id = 414
// module chunks = 0